import styled from 'styled-components';
import { textStyleCss } from 'src/theme/atlas';

export const LegendItemsContainer = styled.div<{
  variant: string;
  isInteractive: boolean;
  overflowHidden: boolean;
  showMoreButtonOpen: boolean;
}>`
  cursor: ${(props) => (props.isInteractive ? 'pointer' : 'auto')};
  display: flex;
  align-items: center;
  user-select: none;
  gap: ${(props) => (props.variant == 'dot' ? '10px 20px' : '10px 24px')};
  padding-top: 20px;
  flex-wrap: wrap;
  ${(props) =>
    props.overflowHidden &&
    !props.showMoreButtonOpen &&
    `
   max-height: 70px;
   overflow: hidden;`}
`;

export const ButtonWrapper = styled.div`
  padding-top: 20px;
`;

export const LegendsText = styled.p`
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.caption)}
  margin: 0;
  max-width: 140px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const LegendsDot = styled.div<{
  color: string;
}>`
  width: 9px;
  height: 9px;
  margin-right: 10px;
  border-radius: 50%;
  background: ${(props) => props.color};
  position: relative;
  -webkit-print-color-adjust: exact;
  print-color-adjust: exact;
`;

export const LegendsDotAndLine = styled(LegendsDot)<{
  color: string;
}>`
  margin-left: 6px;
  margin-right: 15px;
  -webkit-print-color-adjust: exact;
  print-color-adjust: exact;
  &::before {
    content: '';
    display: block;
    height: 1px;
    width: 20px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: ${(props) => props.color};
  }
`;

export const LegendsItem = styled.div<{ disabled: boolean }>`
  display: flex;
  align-items: center;
  opacity: ${(props) => (props.disabled ? 0.4 : 1)};
`;
